import { FileSpreadsheet } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * Calc's app-wide palette entry (I-2348): a new workbook. Calc's workbook view
 * creates it for `?new=workbook` (asking about unsaved changes first); the
 * ribbon's commands and the recent workbooks join the palette while a
 * workbook is open (frontend/calc).
 */
export const calcCommands: CommandFactory = ({ router, t, appLabel: calc }) => [
  appLocationCommand(router, {
    id: 'calc.newWorkbook',
    app: 'calc',
    group: calc,
    label: `${calc}: ${t('calc.workbook.new')}`,
    href: '/calc?new=workbook',
    icon: FileSpreadsheet,
    keywords: ['calc', 'tabelle', 'arbeitsmappe', 'workbook', 'spreadsheet', 'excel', 'neu', 'new'],
  }),
];
